module.exports = fox._r("images/promo/tutorial/09.png", __webpack_public_path__ + "_/common/images/promo/tutorial/09.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/09.png
// module id = 657
// module chunks = 2